// Códigos de erro de política de envio do WhatsApp devolvidos pelos endpoints de envio/edição da
// Fase 1 (403/409/422). Ver docs/features/whatsapp-shared-number/api-contract.md, seção
// "Erros 403/409/422 dos demais endpoints da Fase 1".
//
// Nota sobre o formato: `CallPOSTAPI`/`CallPOSTAPIWithFormData` (src/api/API.js) já entregam o
// corpo JSON de respostas de erro (403/409/422) diretamente ao callback normal (não é preciso um
// errorCallback separado) como `{ success: false, error: 'CODIGO', message?, limit?, actual? }`
// — ver o tratamento de `!response.ok` em API.js (~linha 1753).
export const WHATSAPP_ERROR_CODES = {
  NOT_ALLOWED_ON_PLATFORM_NUMBER: 'NOT_ALLOWED_ON_PLATFORM_NUMBER',
  OWN_NUMBER_UNAVAILABLE: 'OWN_NUMBER_UNAVAILABLE',
  BULK_LIMIT_EXCEEDED: 'BULK_LIMIT_EXCEEDED',
  TEMPLATE_TOO_LONG: 'TEMPLATE_TOO_LONG',
};

const KNOWN_CODES = Object.values(WHATSAPP_ERROR_CODES);

/**
 * @param {any} result - resultado devolvido pelo callback de uma chamada de API
 * @returns {boolean} true se `result.error` for um dos códigos de política do WhatsApp
 */
export function isWhatsAppPolicyError(result) {
  return !!result && KNOWN_CODES.includes(result.error);
}

/**
 * Mensagem pt-BR amigável para um erro de política do WhatsApp.
 * Usa `result.limit`/`result.actual` quando existirem (respostas 422), senão `result.message`,
 * senão o `fallback` informado.
 *
 * @param {any} result
 * @param {string|null} [fallback]
 * @returns {string|null}
 */
export function getWhatsAppErrorMessage(result, fallback = null) {
  if (!isWhatsAppPolicyError(result)) {
    return fallback;
  }

  switch (result.error) {
    case WHATSAPP_ERROR_CODES.NOT_ALLOWED_ON_PLATFORM_NUMBER:
      return 'Esta ação sai só pelo seu próprio número de WhatsApp. Conecte-o em Integrações › WhatsApp.';
    case WHATSAPP_ERROR_CODES.OWN_NUMBER_UNAVAILABLE:
      return 'Seu número de WhatsApp está desconectado. Reconecte em Integrações › WhatsApp.';
    case WHATSAPP_ERROR_CODES.BULK_LIMIT_EXCEEDED:
      if (result.limit != null && result.actual != null) {
        return `Limite do envio em massa excedido (limite: ${result.limit}, atual: ${result.actual}).`;
      }
      return result.message || fallback || 'Limite do envio em massa excedido.';
    case WHATSAPP_ERROR_CODES.TEMPLATE_TOO_LONG:
      if (result.limit != null && result.actual != null) {
        return `O template excede o tamanho máximo permitido (limite: ${result.limit} caracteres, atual: ${result.actual}).`;
      }
      return result.message || fallback || 'O template excede o tamanho máximo permitido.';
    default:
      return result.message || fallback;
  }
}
